<template>
    <input type="text" class="ui-search-field" name="search" placeholder="Search..." :value="inputValue">
</template>

<script>
    export default {
        name: 'ui-search-field',
        props: ['title', 'tools'],
        computed: {
            inputValue() {
                const { tools } = this;
                const currentView = tools.currentView;
                const data = currentView.data;
                if (tools && data.search && data.search.value) {
                    return data.search.value;
                }
                return '';
            }
        },
    }
</script>

<style>
.ui-search-field {
   /*width: 130px;*/
   box-sizing: border-box;
   border: 2px solid #ccc;
   border-radius: 2px;
   font-size: 13px;
   background-color: white;
   background-position: 10px 10px;
   background-repeat: no-repeat;
   padding: 5px;
   border-radius: 5px;
   text-align: center;
   /*margin:10px;*/
}

.ui-search-field:focus {
    text-align: left;
}

</style>



// WEBPACK FOOTER //
// UiSearchfield.vue?79114700